<template>
  <div>
    <panel background-color="#fffee0" style="text-align: center; border: 1px solid #000;">
      Price shown includes transportation fee to bring parcel across the border.<br />
      Delivery dates based on shipment being dropped off at <a href="https://goo.gl/maps/MKFW6YSMMNv4odpj6">our warehouse</a> <br>
      <strong>before 10:00 am Mon-Fri</strong>
    </panel>

    <panel>
      <h4>Selected Shipping</h4>
      <shipping-rate background-color="#fff" :selectable="false" v-bind="rate"></shipping-rate>
      <div class="pickup" v-if="requestedPickup">
        <h4>Pickup requested</h4>
        <div class="pickup-price">
          <div>{{ 1500 | formattedPrice(rate.currency) }} <span class="pickup-currency">{{ rate.currency }}</span></div>
        </div>
      </div>
    </panel>

    <panel>
      <h4>Payment Details</h4>
      <credit-card
          :total="total"
          :currency="rate.currency"
          :client-secret="clientSecret"
          :return-url="returnUrlWithValues"
          v-on="$listeners"
          :shipment-id="shipmentId"
      ></credit-card>
    </panel>
  </div>
</template>

<style scoped>
.pickup{
  display: flex;
  padding: 20px;
  align-items: center;
}
.pickup-price {
  margin-left: auto;
  white-space: nowrap;
  font-weight: 700;
}

.pickup-currency {
  font-weight: 700;
  font-size: 13.5px;
  line-height: 150%;
  color: #929292;
}
</style>

<script>

export default {
  components: {
  },
  props: {
    rate: Object,
    clientSecret: String,
    returnUrl: String,
    shipmentId: String,
    formData: FormData,
    requestedPickup: Boolean,
  },
  data: () => ({
    paymentStatus: false,
  }),
  methods: {
  },
  computed: {
    returnUrlWithValues: function(){
      return this.returnUrl
          .replace(':shipmentId', this.shipmentId);
    },
    pickupFee: function(){
      return this.requestedPickup ? 1500 : 0;
    },
    total: function(){
      return this.rate.total + this.pickupFee;
    },
  }
}
</script>
